import React from 'react';
import UI from './ui';

const RequestIdForm = props => <UI {...props} />;

export default RequestIdForm;
